module.exports = __webpack_public_path__ + "img/corn-n-soy.85755367.jpeg";